function formValidation() {
    var validation = true;
    $('.form-error').remove();
    $('.input-row').removeClass('error');
    $('input[data-required=true], select[data-required=true], textarea[data-required=true]').each(function (index, element) {
	if (!$(this).val() || $(this).val() == -1) {
	    $(this).parents('.input-row').addClass('error').append('<span class="form-error">' + $(this).data('validate-message') + '</span>');
	    validation = false;
	} else if($(this).attr("type")==="email") {
	    if(!validateEmail($(this).val())) {
		$(this).parents('.input-row').addClass('error').append('<span class="form-error">' + $(this).data('validate-message-type') + '</span>');
		validation = false;
	    }
	}
    });
    return validation;
}
function elementValidate(el) {
    var el = el;
    var validation = true;
    el.parents('.input-row').children('.form-error').remove();
    el.parents('.input-row').removeClass('error');
    if (!el.val() || el.val() == -1) {
	    el.parents('.input-row').addClass('error').append('<span class="form-error">' + el.data('error-alert') + '</span>');
	    validation = false;
    }
}
function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

// function contactFormSubmit(token) {
//     var validate = formValidation();
//     if(!validate) {
// 	    grecaptcha.reset();
//     } else {
//
// 	    document.querySelector('.contact-form').submit();
//     }
// }

function submitContactForm(e) {
    e.preventDefault();
    var validate = formValidation();
    var contactForm = document.getElementById('modal-form');
    var contactFormSubmitButton = document.querySelector('button[type="submit"]');
    var contactFormToken = document.querySelector('input[name="token"]');
    if(validate===true) {
        // grecaptcha.ready(function() {
        //     grecaptcha.execute(contactForm.getAttribute('data-sitekey'),{action: 'submit_demand'}).then(function(token) {
        //         contactFormToken.value = token;
                contactFormSubmitButton.innerHTML = '<span class="icon-envelope"></span> Odesílám';
                contactFormSubmitButton.setAttribute('disabled',true);
                contactForm.submit();
        //     });
        // });
    } else {
        console.log()
    }

}

function checkObsazenostFirmy(firm_id) {
    if(firm_id.length > 0) {
        if($(".contact-form .poptavka-dostupnost-obsazeno-" + firm_id).length>0) {
            $(".contact-form .poptavka-dostupnost-obsazeno-" + firm_id).remove();
        }
        $.ajax({
            type: "GET",
            url: "/ajax/",
            data: {firm_id: firm_id, arrive: $('.contact-form input[name="date_from"]').val(), departure: $('.contact-form input[name="date_to"]').val(), f: "aa67a7be9dc77399ce0dc7f97b41384a"},
            dataType: "json",
            success: function(r){
                if(r.status) {
                    if(r.obsazeno) {
                        var nazev = r.nazev;
                        $(".contact-form #term-and-person").after('<div class="poptavka-dostupnost-obsazeno-' + firm_id + ' text-danger">' + nazev + ' má v tomto termínu obsazeno</div>');
                        return false;
                    } else {
                        // neni obsazeno
                    }
                } else {
                    // neco spatne
                }
            }
        });
    }
}

function checkObsazenost() {
    $('.contact-form input[name^="fid"]').each(function() {
        var firm = $(this).val();
        if(typeof firm !== "undefined") {
            checkObsazenostFirmy(firm);
        }
    });
}



$(document).bind('ready ajaxComplete', function(){
    $('.contact-form button[type="submit"]:not([disabled])').on('click',function(e){
        submitContactForm(e);
    });
});